var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.info)?_c('span',{staticClass:"info-tooltip ml-10",attrs:{"data-text":_vm.info}},[_c('info-tooltip-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.topright.html",value:({
      customClass: 'tooltip-custom',
      title: _vm.info,
    }),expression:"{\n      customClass: 'tooltip-custom',\n      title: info,\n    }",modifiers:{"hover":true,"topright":true,"html":true}}],attrs:{"color":'#C5C5C5'}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }